<template>
	<div>
		<h1>{{title}}</h1>
		<hr/>
		<p class="text-area">{{text}}</p>
	</div>
</template>

<script>
	export default {
		props:{
			"data":Object
		},
		computed:{
			title(){
				return this.data.settings.title;
			},
			text(){
				return this.data.settings.text;
			}
		}
	}
</script>

<style scoped lang="scss">
	.text-area{
		white-space:pre-wrap;
	}
</style>